<template>
  <div id="app">
    <router-view id="content"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  metaInfo: () => ({
    link: [{ rel: "favicon", href: "favicon.ico" }],
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "PIA – Participatory Image Archives",
    // all titles will be injected into this template
    description: "Synergia Project 2021–2025",
  }),
}
</script>

<style lang="scss">
</style>
